(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-accordion-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-luxo-gallery-row]').forEach(function (row) {
      var panels = Array.prototype.slice.call(row.querySelectorAll('[data-luxo-panel]'));

      function setActive(idx) {
        panels.forEach(function (p, i) {
          p.classList.toggle('is-active', i === idx);
        });
      }

      panels.forEach(function (panel, i) {
        panel.addEventListener('mouseenter', function () {
          setActive(i);
        });
        panel.addEventListener('focus', function () {
          setActive(i);
        });
        panel.addEventListener('click', function (e) {
          if (!panel.classList.contains('is-active')) {
            e.preventDefault();
            setActive(i);
          }
        });
        panel.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            var next = Math.min(i + 1, panels.length - 1);
            setActive(next);
            panels[next].focus();
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            var prev = Math.max(i - 1, 0);
            setActive(prev);
            panels[prev].focus();
          }
        });
      });
    });

    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-craft-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cta-band"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-faq-section .luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-page"] && !Shopify.designMode) return;
  try {
    
  function luxoPdp2Init() {
    document.querySelectorAll('.luxo-pdp2-thumbs').forEach(function (thumbRow) {
      var gallery = thumbRow.closest('.luxo-pdp2-gallery');
      var mainImg = gallery ? gallery.querySelector('#luxoPdp2MainImg') : document.getElementById('luxoPdp2MainImg');
      function showThumb(btn) {
        thumbRow.querySelectorAll('.luxo-pdp2-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (mainImg && btn.dataset.full) {
          // image_tag auto-generates a srcset, which browsers prioritize over
          // src — clear it so the swapped-in image actually takes effect.
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = btn.dataset.full;
        }
      }

      thumbRow.querySelectorAll('.luxo-pdp2-thumb').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          showThumb(btn);
        });
        // Hover (mouse/trackpad only — avoids accidentally firing on touch taps)
        btn.addEventListener('mouseenter', function () {
          if (matchMedia('(hover: hover)').matches) showThumb(btn);
        });
      });

      // Swipe on the main image (mobile) to step to the next/previous photo.
      var mainImgLink = gallery ? gallery.querySelector('.luxo-pdp2-main-img') : null;
      if (mainImgLink) {
        var touchStartX = null;
        var touchStartY = null;
        var SWIPE_THRESHOLD = 40; // px — below this, treat it as a tap/scroll, not a swipe

        mainImgLink.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches[0]) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });

        mainImgLink.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var touch = e.changedTouches && e.changedTouches[0];
          var startX = touchStartX;
          var startY = touchStartY;
          touchStartX = null;
          touchStartY = null;
          if (!touch) return;

          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          // Ignore short drags and mostly-vertical ones (that's page scroll,
          // not an attempt to change photos).
          if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;

          var thumbs = Array.prototype.slice.call(thumbRow.querySelectorAll('.luxo-pdp2-thumb'));
          if (thumbs.length < 2) return;
          // A real swipe — stop it from also firing the image link's tap/click.
          e.preventDefault();

          var activeIndex = thumbs.findIndex(function (b) { return b.classList.contains('is-active'); });
          if (activeIndex === -1) activeIndex = 0;
          // Swipe left = next photo, swipe right = previous photo; wraps around at the ends.
          var nextIndex = dx < 0
            ? (activeIndex + 1) % thumbs.length
            : (activeIndex - 1 + thumbs.length) % thumbs.length;
          showThumb(thumbs[nextIndex]);
        });
      }
    });

    // The displayed number is a "quantity to add" indicator, not a live
    // mirror of the cart: it shows 1 by default (never 0), stays on 1
    // through the very first Add to Cart click (that click adds the 1st
    // unit, which is what the "1" already represented), and only advances
    // to 2, 3, ... on subsequent clicks once there's really more than one
    // in the cart. It's kept in sync with the true cart quantity underneath
    // (floored at 1 for display) so it never drifts from what's actually
    // in the cart.
    document.querySelectorAll('.luxo-pdp2-actions').forEach(function (form) {
      var qtyEl = form.querySelector('.luxo-qty');
      if (!qtyEl) return;

      var input = qtyEl.querySelector('.luxo-qty__input');
      var minusBtn = qtyEl.querySelector('.luxo-qty__minus');
      var plusBtn = qtyEl.querySelector('.luxo-qty__plus');
      var variantInput = form.querySelector('input[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      var busy = false;
      // True quantity of this variant in the cart, as last confirmed by the
      // server. null until the first sync — used (not the floored display
      // value) to decide whether "-" has anything real to remove.
      var actualQty = null;

      function dispatchCartUpdate(cart) {
        var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        evt.promise = Promise.resolve({
          cart: { totalQuantity: cart.item_count },
          detail: { itemCount: cart.item_count },
        });
        document.dispatchEvent(evt);
      }

      function updateMinusState() {
        minusBtn.disabled = !actualQty;
      }

      // Re-reads the real cart, stores the true quantity, and sets the
      // displayed number from it (floored at 1) so the display can't drift
      // from what's actually in the cart while still never showing 0.
      function refreshFromCart() {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var qty = 0;
            (cart.items || []).forEach(function (item) {
              if (String(item.variant_id) === String(variantId)) qty += item.quantity;
            });
            actualQty = qty;
            input.value = Math.max(qty, 1);
            updateMinusState();
            dispatchCartUpdate(cart);
          });
      }

      function addOne() {
        if (!variantId || busy) return;
        busy = true;
        // /cart/change.js only updates a line that's already in the cart —
        // it silently no-ops on the first add. /cart/add.js both creates
        // the line the first time and increments it on every add after.
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(refreshFromCart)
          .catch(function () {})
          .then(function () { busy = false; });
      }

      function removeOne() {
        if (!variantId || busy || !actualQty || actualQty <= 0) return;
        busy = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: actualQty - 1 }),
        })
          .then(refreshFromCart)
          .catch(function () {})
          .then(function () { busy = false; });
      }

      // Sync the true cart quantity on load — the server-rendered value is
      // floored at 1 for display and may not match what's really in the cart.
      refreshFromCart();

      minusBtn.addEventListener('click', function () {
        removeOne();
      });

      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addOne();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addOne();
      });

      // If a variant picker on this page changes which variant is
      // selected, keep this form's tracked variantId (and cart sync) in
      // step with it.
      form.addEventListener('luxo:variant-change', function (e) {
        variantId = e.detail && e.detail.variantId ? String(e.detail.variantId) : variantId;
        refreshFromCart();
      });
    });

    document.querySelectorAll('[data-luxo-delivery]').forEach(function (card) {
      var leadDays = parseInt(card.dataset.leadDays, 10);
      if (isNaN(leadDays)) leadDays = 5;
      var cutoffHour = parseInt(card.dataset.cutoffHour, 10);
      if (isNaN(cutoffHour)) cutoffHour = 18;

      var dateEl = card.querySelector('[data-luxo-delivery-date]');
      var countEl = card.querySelector('[data-luxo-delivery-countdown]');

      function update() {
        var now = new Date();
        var cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);

        var extraDay = 0;
        var msLeft;
        if (now < cutoff) {
          msLeft = cutoff - now;
        } else {
          var nextCutoff = new Date(cutoff);
          nextCutoff.setDate(nextCutoff.getDate() + 1);
          msLeft = nextCutoff - now;
          extraDay = 1;
        }

        var totalMinutes = Math.max(0, Math.floor(msLeft / 60000));
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        if (countEl) countEl.textContent = hours + 'h ' + minutes + 'm';

        var deliveryDate = new Date(now);
        deliveryDate.setDate(deliveryDate.getDate() + leadDays + extraDay);
        var formatted = deliveryDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
        if (dateEl) dateEl.textContent = formatted;
      }

      update();
      setInterval(update, 60000);
    });
  }

  // Renders the Color/Size swatch picker (when the product has real
  // options), keeps it wired to the hidden variant id, price, add-to-cart
  // state, and swaps the gallery to a variant's own photo when it has one —
  // falling back to the full product gallery for variants that don't.
  function luxoPdp2VariantPickerInit() {
    document.querySelectorAll('[data-luxo-variant-picker]').forEach(function (picker) {
      var info = picker.closest('.luxo-pdp2-info');
      if (!info) return;
      var form = info.querySelector('.luxo-pdp2-actions');
      var jsonScript = info.querySelector('[data-luxo-variant-json]');
      if (!form || !jsonScript) return;

      var variants;
      try {
        variants = JSON.parse(jsonScript.textContent);
      } catch (e) {
        return;
      }

      var idInput = form.querySelector('input[name="id"]');
      var addBtn = form.querySelector('button[type="submit"]');
      var priceNow = info.querySelector('.luxo-pdp2-price .now');
      var priceWas = info.querySelector('.luxo-pdp2-price .was');
      var priceOff = info.querySelector('.luxo-pdp2-price .off');
      var layout = info.closest('.luxo-pdp2-layout');
      var gallery = layout ? layout.querySelector('.luxo-pdp2-gallery') : null;
      var mainImg = gallery ? gallery.querySelector('#luxoPdp2MainImg') : null;
      var thumbRow = gallery ? gallery.querySelector('.luxo-pdp2-thumbs') : null;
      var allThumbs = thumbRow ? Array.prototype.slice.call(thumbRow.querySelectorAll('.luxo-pdp2-thumb')) : [];

      function currentSelection() {
        return Array.prototype.slice.call(picker.querySelectorAll('.luxo-pdp2-option')).map(function (group) {
          var active = group.querySelector('.luxo-pdp2-swatch.is-active');
          return active ? active.dataset.value : null;
        });
      }

      function findVariant(selection) {
        return variants.filter(function (v) {
          return selection.every(function (val, i) {
            var key = 'option' + (i + 1);
            return val == null || v[key] === val;
          });
        })[0];
      }

      function applyVariant(variant) {
        if (!variant) return;

        if (idInput) idInput.value = variant.id;
        form.dispatchEvent(new CustomEvent('luxo:variant-change', { detail: { variantId: variant.id } }));

        if (priceNow) priceNow.textContent = variant.price_html;
        if (variant.compare_at_price_html) {
          if (priceWas) { priceWas.textContent = variant.compare_at_price_html; priceWas.hidden = false; }
          if (priceOff) { priceOff.textContent = 'Save ' + variant.pct_off + '%'; priceOff.hidden = false; }
        } else {
          if (priceWas) priceWas.hidden = true;
          if (priceOff) priceOff.hidden = true;
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        if (mainImg) {
          if (variant.image_id) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = variant.image_src;
            allThumbs.forEach(function (t) {
              var match = String(t.dataset.mediaId) === String(variant.image_id);
              t.style.display = match ? '' : 'none';
              t.classList.toggle('is-active', match);
            });
          } else {
            // No image tied to this variant — fall back to the full product gallery.
            allThumbs.forEach(function (t) {
              t.style.display = '';
              t.classList.remove('is-active');
            });
            if (allThumbs.length) {
              allThumbs[0].classList.add('is-active');
              mainImg.removeAttribute('srcset');
              mainImg.removeAttribute('sizes');
              mainImg.src = allThumbs[0].dataset.full;
            }
          }
        }
      }

      picker.querySelectorAll('.luxo-pdp2-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.luxo-pdp2-option');
          group.querySelectorAll('.luxo-pdp2-swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          applyVariant(findVariant(currentSelection()));
        });
      });

      // Sync the gallery/price/add-to-cart state to whichever variant is
      // selected on load (covers a direct link with a ?variant= param).
      applyVariant(findVariant(currentSelection()));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', luxoPdp2Init);
    document.addEventListener('DOMContentLoaded', luxoPdp2VariantPickerInit);
  } else {
    luxoPdp2Init();
    luxoPdp2VariantPickerInit();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });

    document.querySelectorAll('.luxo-pdp-thumbs').forEach(function (thumbRow) {
      var mainImg = thumbRow.closest('.luxo-pdp-gallery').querySelector('#luxoPdpMainImg');
      thumbRow.querySelectorAll('.luxo-pdp-thumb').forEach(function (btn) {
        btn.addEventListener('click', function () {
          thumbRow.querySelectorAll('.luxo-pdp-thumb').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (mainImg && btn.dataset.full) mainImg.src = btn.dataset.full;
        });
      });
    });

    document.querySelectorAll('.luxo-qty').forEach(function (qty) {
      var input = qty.querySelector('.luxo-qty__input');
      qty.querySelector('.luxo-qty__minus').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      qty.querySelector('.luxo-qty__plus').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-showcase-gallery"] && !Shopify.designMode) return;
  try {
    
  // Only play each bento tile's video once it's actually visible, and pause
  // it again when it scrolls out of view -- avoids decoding/rendering four
  // looping videos at once on page load, which was costing real scroll
  // smoothness for no visible benefit (below-the-fold tiles weren't seen yet
  // anyway).
  document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('.luxo-bento__video');
    if (!videos.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.readyState === 0) {
              video.load();
            }
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.1 }
    );

    videos.forEach(function (video) {
      io.observe(video);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-stats"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });

    var counters = document.querySelectorAll('.luxo-stat-num');
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.count);
        var isDecimal = target % 1 !== 0;
        var cur = 0;
        var step = target / 60;
        function tick() {
          cur += step;
          if (cur >= target) {
            el.textContent = isDecimal ? target.toFixed(1) : target.toLocaleString();
            return;
          }
          el.textContent = isDecimal ? cur.toFixed(1) : Math.floor(cur).toLocaleString();
          requestAnimationFrame(tick);
        }
        tick();
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { cio.observe(c); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-value-props"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.luxo-values-section .luxo-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      io.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
